module.exports = __webpack_public_path__ + "static/index/img/baikal-500.a4bcca46.jpg";